
/**
 * @param {*} self
 * 获取酒店房间详情信息
 * 获取酒店价格计划
 * 然后将价格计划匹配到房间信息中
 * return hotelRoom
 * @param {*} obj 
 * =============================
 * htQuery/hotelRoom
 * amount (integer, optional): 房型数量 ,
 * area (string, optional): 面积 ,
 * bedType (string, optional): 床型 ,
 * broadnetAccess (integer, optional): 上网情况 0表示无宽带，1 表示有宽带, 2 表示有WIFI ,
 * broadnetFee (integer, optional): 上网费用 0表示免费，1 表示收费 ,
 * capacity (integer, optional): 房间最大入住人数 ,
 * comments (string, optional): 备注 ,
 * description (string, optional): 描述 包括大床、双床、宽带等一类描述 ,
 * facilities (string, optional): 房间设施 结构化的设施 ,
 * floor (string, optional): 楼层 ,
 * fxid (string, optional): 房型id ,
 * fxmc (string, optional): 房型名称 ,
 * imageUrl (string, optional): 图片的http地址 ,
 * jdid (integer, optional): 酒店id
 * window (integer, optional): 酒店窗型
 * 
 * 
 * htQuery/hotelPlanSearch
 * checkInDate (string, optional): 入住日期 ,
 * checkOutDate (string, optional): 离店日期 ,
 * hotelId (string, optional): 本地酒店id ,
 * hotelName (string, optional): 酒店名称 ,
 * lowRate (string, optional): 最低价格 ,
 * rooms (Array[HotelPlanSearchRoomBean], optional): 房间节点
 * 
 * [HotelPlanSearchRoomBean] 
 * facePayNums (integer, optional): 到店付产品数量 ,
 * minFacePrice (number, optional): 前台到店付最低价 这个房型，首日，所有接口，对应的所有价格计划中 最低的价格 ,
 * prePayNums (integer, optional): 预付产品数量 ,
 * ratePlans (Array[HotelPlanSeachRatePlanBean], optional): 产品信息,价格计划信息 ,
 * roomId (string, optional): 本地房型id ,
 * roomName (string, optional): 房型名称
 * 
 * [HotelPlanSeachRatePlanBean]
 * allRoomStatus (string, optional): 综合房态,0良好,1紧张,2满房,3需确认,currentAlloment跟仅剩的房量 ,
 * bookingRule ([HotelPlanSearchRatePlanBookingRuleBean], optional): 预订规则 ,
 * bussType (integer, optional): 企业协议价或服务商协议价,1是服务商,2是企业协议价 ,
 * currencyCode (string, optional): 货币 ,
 * customerType (string, optional): 客人类型。。All=统一价 Chinese =内宾价，需提示客人“须持大陆身份证入住”;OtherForeign =外宾价，需提示客人“须持国外护照入住”;HongKong =港澳台客人价，需提示客人“须持港澳台身份证入住”;Japanese=日本客人价，需提示客人“须持日本护照入住” ,
 * firstCostPrice (string, optional): 供应商成本价:为预付，且是代理人房源才有 ,
 * firstJj (number, optional): 首日加价 ,
 * firstPrice (number, optional): 首日房价:供应商销售价 ,
 * freeMeal (integer, optional): 早餐份数,所有夜晚数早餐数量的小计 ,
 * fyid (string, optional): 当时singa平台时，真实价格来源编号 ,
 * guaranteeRule ([HotelPlanSearchRatePlanGuaranteeRuleBean], optional): 担保规则 ,
 * guestMsg (string, optional): 适用人群信息 ,
 * havailPolicy ([HotelPlanSearchRatePlanHAvailPolicyBean], optional): 酒店特殊信息提示 ,
 * invoiceMode (string, optional): 预付产品发票模式: YJPMS ld科技开具发票；Hotel 酒店开具；为空，表示这个产品没有发票 ,
 * nightlyRates (Array[HotelGjShoppingPricePlanListRoomRateNightlyBean], optional): 每天价格数组 ,
 * payment (string, optional): 支付类型:1到店付 2预付 ,
 * prepayRule ([HotelPlanSearchRatePlanPrepayRuleBean], optional): 预付规则 ,
 * productTypes (string, optional): 产品特性类型,3-限时抢购 4-钟点房 5-手机专享 ,
 * ratePlanFrom (string, optional): 价格来源,2000001 SINGA平台 为空表示本地 取值@see InterfacePlatEnum ,
 * ratePlanId (string, optional): 产品编号。价格计划id ,
 * roomId (string, optional): 房型id ,
 * roomName (string, optional): 房型名称 ,
 * rpName (string, optional): 产品名称 ,
 * shortRule (string, optional): 简短的规则说明：11无需担保；12限时担保；13强制担保；21免费取消；22限时取消；23不可取消 ,
 * suffixName (string, optional): 房型信息的补充说明,展示在前端 ,
 * supplierCode (string, optional): 供应商代码 即服务商总公司代码 ,
 * supplierId (string, optional): 供应商id 即服务商总公司ID ,
 * supplierName (string, optional): 供应商名称 即服务商总公司名称 ,
 * supportForeignGuests (boolean, optional): 是否支持外宾入住 ,
 * totalFwf (number, optional): 入住时间段内的单间服务费，如果多间房，那么订单总服务费=单间服务费*房间数，指定价格计划查询时才会进行匹配返回 ,
 * totalJj (number, optional): 入住时间段内的单间总加价 ,
 * totalRate (number, optional): 入住时间段内的单间销售价，单间成本价+单间加价 ,
 * totalRateOld (number, optional): 入住时间段内的单间成本价 ,
 * valueAdd ([HotelPlanSearchRatePlanValueAddBean], optional): 增值服务
 * 
 * [HotelPlanSearchRatePlanBookingRuleBean]
 * bookingRuleId (string, optional): 预订规则编号 ,
 * description (string, optional): 描述
 * 
 * [HotelPlanSearchRatePlanGuaranteeRuleBean]
 * amount (string, optional): 担保的房间数,预定几间房以上要担保 ,
 * changeRule (string, optional): 变更规则。担保规则取消变更规则 ,
 * dateType (string, optional): 日期类型 ,
 * description (string, optional): 描述 ,
 * endDate (string, optional): 结束日期 ,
 * endTime (string, optional): 到店担保结束时间。用于IsTimeGuarantee ==true进行检查。。 ,
 * guaranteeType (string, optional): 保类型。FirstNightCost为首晚房费担保;FullNightCost为全额房费担保 ,
 * guranteeRuleId (string, optional): 担保规则编号 ,
 * isAmountGuarantee (string, optional): 是否房量担保。False:为不校验房量条件 True:为校验房量条件 ,
 * isTimeGuarantee (string, optional): 是否到店时间担保。False:为不校验到店时间 True:为需要校验到店时间 ,
 * startDate (string, optional): 开始日期 ,
 * startTime (string, optional): 到店担保开始时间。
 * 
 * [HotelPlanSearchRatePlanHAvailPolicyBean]
 * availPolicyText (string, optional): 提示内容 ,
 * description (string, optional): 描述 ,
 * id (string, optional): 提示编号
 * 
 * [HotelGjShoppingPricePlanListRoomRateNightlyBean]
 * breakfastCount (integer, optional): 早餐数量 ,
 * date (string, optional): 当天日期 ,
 * jj (number, optional): 加价 ,
 * priceAfterTax (number, optional): 已经通过计算可以直接显示给客人。价格为-1表示不能销售。成本价 ,
 * priceBeforTax (number, optional): 税前价 ,
 * salePrice (number, optional): 销售价;成本价 + 加价 ,
 * status (string, optional): 库存状态。true 表示当天库存可用 ,
 * tax (number, optional): 税费
 * 
 * [HotelPlanSearchRatePlanPrepayRuleBean]
 * changeRule (string, optional),
 * description (string, optional): 描述 ,
 * prepayRuleId (string, optional): 规则编码
 * 
 * [HotelPlanSearchRatePlanValueAddBean]
 * description (string, optional): 附加服务描述，代理不想解析的话，可以直接显示该描述 ,
 * valueAddId (string, optional): 增值服务编号
 */
export function getHotelRoom (self, obj) { // export async
  return new Promise((resolve, reject) => {
    /**
     * 获取酒店价格计划
     */
    self.$api['htQuery/pricePlanList']({
      hotelId: obj.jdid, // 平台酒店id，列表查询返回的酒店ID
      interfacePlatEnum: obj.interfacePlatEnum, // 接口供应商标识，列表查询返回的接口供应商标识
      checkInDate: obj.checkInDate, // 入住日期：yyyy-mm-dd
      checkOutDate: obj.checkOutDate, // 离店日期：yyyy-mm-dd
      roomId: '', // 平台房型编号，传入时表示指定房型查询
      ratePlanId: '', // 价格计划id,重选日期的时候使用
      payment: '', // 支付方式：0到店付 1预付
      corpId: '', // 企业id,OSS选择企业后需传入，OBT可不传入
      tripType: obj.tripType, // 出差类型 1:因公 2因私，默认1
      singaZhid: self.interfacePlat.singaZhid,
      searchPlatZhid: self.interfacePlat.platZhid,
      protocol: obj.protocol, //是否协议酒店标识
      hotelInterfaceBeans: obj.hotelInterfaceBeans // 聚合酒店供应
    }).then((res_) => {
      if (!res_.data) res_.data = { rooms: [] }

      Promise.all([
        
        // 图片信息
        new Promise(async (resolve, reject) => {
          try {
            let res = await self.$api['htQuery/imgInfo']({
              jdid: obj.jdid, // 平台酒店id，列表查询返回的酒店ID
              interfacePlatEnum: self.interfacePlat.interfacePlatId, // 接口供应商标识，列表查询返回的接口供应商标识
              fxid: '',
              imgSize: 1,
              imgType: '1,2,3,5,6,8,10,11,12',
              singaZhid: self.interfacePlat.singaZhid,
              platZhid: self.interfacePlat.platZhid,
              protocol: obj.protocol //是否协议酒店标识
            })

            if (!res.data || !res.data.hotelImgs) res.data = { hotelImgs: [], roomsImgs: [] }
            
            resolve(res)
          } catch (error) {
            reject(error)
          }
        }),
        
        // 房型信息
        new Promise(async (resolve, reject) => {
          try {
            let res = await self.$api['htQuery/hotelInfo']({
              jdid: obj.jdid,
              interfacePlatEnum: self.interfacePlat.interfacePlatId,
              singaZhid: self.interfacePlat.singaZhid,
              protocol: obj.protocol //是否协议酒店标识
            })
            
            if (!res.data) res.data = { hotelRoom: [] }

            resolve(res)
          } catch (error) {
            reject(error)
          }
        }),
        
        new Promise(async (resolve, reject) => {
          try {
            let res = await self.$api['htQuery/roomInfo']({
              checkInDate: obj.checkInDate, // 入住日期：yyyy-mm-dd
              checkOutDate: obj.checkOutDate, // 离店日期：yyyy-mm-dd
              jdid: obj.jdid, // 平台酒店id，列表查询返回的酒店ID
              interfacePlatEnum: self.interfacePlat.interfacePlatId, // 接口供应商标识，列表查询返回的接口供应商标识
              roomId: '', // 供应商房型id
              sourceFrom: '', // 数据来源 传入1或空表示通过静态接口获取,2则通过动态接口查询
              singaZhid: self.interfacePlat.singaZhid,
              platZhid: self.interfacePlat.platZhid,
              protocol: obj.protocol //是否协议酒店标识
            })

            /**
             * 价格计划匹配到房间信息中
             */
            res_.data.rooms.forEach(element_ => {
              element_['fxid'] = element_.roomId
              element_['fxmc'] = element_.roomName
              element_['visible'] = false	
            })

            if (res.data && res_.data.rooms) {
              res_.data.rooms.forEach(element_ => {
                res.data.forEach(element => {
                  if (element.fxid == element_.roomId) {
                    element_['fxid'] = element.fxid
                    element_['fxmc'] = element.fxmc
                    element_['description'] = element.description || ''
                    element_['area'] = element.area || ''
                    element_['floor'] = element.floor || ''
                    element_['broadnetAccess'] = element.broadnetAccess || ''
                    element_['broadnetFee'] = element.broadnetFee || ''
                    element_['bedType'] = element.bedType || ''
                    element_['comments'] = element.comments || ''
                    element_['capacity'] = element.capacity || ''
                    element_['imageUrl'] = element.imageUrl || ''
                    element_['window'] = element.window || ''  
                  }
                })
              })
            }
            resolve(res_.data.rooms)
          } catch (error) {
            reject(error)
          }
        }),

      ]).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })

    }).catch(res => {
      reject(res)
    })
  })
}